// constants files are not allowed to import anything other than Types,
// this file name should be renamed !!! we temporarily disable the rule here.
import { token } from '@terra/ui-styled-system';
import {
  ArrowLeftRightIcon,
  Database01Icon,
  GitForkIcon,
  ListStartIcon,
  ComputerIcon,
  Route01Icon,
  Settings01Icon,
  WorkflowSquare01Icon,
  type TerraIcon,
} from '@terra/ui-icons';
import type { GraphNodeType } from './types';

export const NodeIconMap: Record<GraphNodeType, TerraIcon> = {
  CLIENT: ComputerIcon,
  ROUTING: Route01Icon,
  MIDDLEWARE: GitForkIcon,
  LOGIC: ArrowLeftRightIcon,
  UTILITY: WorkflowSquare01Icon,
  EVENT: ListStartIcon,
  DATABASE: Database01Icon,
  CONFIGURATION: Settings01Icon,
};
export const NodeColorMap: Record<GraphNodeType, string> = {
  CLIENT: token('colors.orange.10'),
  ROUTING: token('colors.orange.10'),
  MIDDLEWARE: token('colors.violet.10'),
  LOGIC: token('colors.violet.10'),
  UTILITY: token('colors.violet.10'),
  EVENT: token('colors.crimson.10'),
  DATABASE: token('colors.crimson.10'),
  CONFIGURATION: token('colors.crimson.10'),
};
export const NODE_DEFAULT_WIDTH = 180;
export const NODE_DEFAULT_HEIGHT = 80;
